import { VALUE_DIRECTION } from '@/constants';
import { formatUnit } from '@/utils/string-utils';
import React from 'react';
import styled from 'styled-components';
import { HeaderSm } from './header-sm';
import * as kpi from './kpi-ribbon-sm-styles';
import { TrendDisplay } from './trend-display';

const ValueRowWrapper = styled(kpi.ValueRow)`
  padding-top: 0px;
  padding-bottom: 0px;
  gap: 4px;
`;

/**
 * Header component for bookings activities
 *
 * @param {string} props.label The header text
 * @param {string} props.labelFontSize The header css font-size
 * @param {string} props.valueFontSize The value css font-size
 * @param {object} props.latestKpi The latest kpi data point object
 * @param {string} props.latestKpiDescription A breif description of the latest kpi data point
 * @param {boolean} props.expand A flag which makes this header fill all the parents usable space.
 * @param {boolean} props.enableTrend A flag used to determine if the trend icon will be rendered.
 * @param {string} props.symbol A unit value to identify the type of kpi data.
 * @param {boolean} props.showTotalBooked A flag which determines if the total booked will be rendered.
 * @param {number} props.totalBooked The sum value of all bookings
 * @param {string} props.totalBookedDescription A breif description of the total booked data
 * @param {React.ReactNode} props.children
 */
export function KpiBookingActivities(props) {
  const {
    label,
    latestKpi,
    labelFontSize,
    valueFontSize,
    expand,
    enableTrend,
    latestKpiDescription,
    symbol,
    showTotalBooked,
    totalBooked,
    totalBookedDescription,
    children,
  } = props;
  const { trend, value, amountChange } = latestKpi;
  const rise = trend === 'rise';

  return (
    <HeaderSm labelFontSize={labelFontSize} label={label}>
      <ValueRowWrapper expand={expand}>
        <kpi.Col>
          <kpi.ValueRow expand={expand}>
            <kpi.ValueWrapper>
              <TrendDisplay
                enableTrend={enableTrend}
                value={formatUnit(value, symbol)}
                isActive={true}
                trend={trend}
                valueFontSize={valueFontSize}
              />
            </kpi.ValueWrapper>
            <kpi.DeltaChildrenWrapper expand={expand}>
              <kpi.Delta rise={Boolean(rise)}>
                {formatUnit(
                  amountChange,
                  symbol,
                  false,
                  rise ? VALUE_DIRECTION.INCREASE : VALUE_DIRECTION.DECREASE
                )}
              </kpi.Delta>
              {children}
            </kpi.DeltaChildrenWrapper>
          </kpi.ValueRow>
          {latestKpiDescription && (
            <kpi.Description>{latestKpiDescription}</kpi.Description>
          )}
        </kpi.Col>
        {showTotalBooked && (
          <kpi.Col>
            <kpi.ValueRow expand={expand}>
              <TrendDisplay
                enableTrend={enableTrend}
                value={formatUnit(totalBooked)}
                isActive={true}
                trend={trend}
                valueFontSize={valueFontSize}
              />
            </kpi.ValueRow>
            {totalBookedDescription && (
              <kpi.Description>{totalBookedDescription}</kpi.Description>
            )}
          </kpi.Col>
        )}
      </ValueRowWrapper>
    </HeaderSm>
  );
}
